import styled from 'styled-components';

export default styled.div`
    .textField {
        max-width: 100%;
    }
`;